module.exports = __webpack_public_path__ + "img/emoji_105.24abde21.png";